// layouts/RevenueBilling/index.js
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { Card } from '@mui/material';

function RevenueBilling() {
  return (
    <Card>
      <ArgonBox p={3} textAlign="center">
        <ArgonTypography variant="body2" color="text">
          No revenue and billing logic defined for this catalogue.
        </ArgonTypography>
      </ArgonBox>
    </Card>
  );
}

export default RevenueBilling;
